import moment from 'moment'

export const isReportDateTimeParameter = (item = {}) =>
  item.paramType === 'datetime' ||
  (!item.paramType && /datetime/i.test(item.field || item.title || ''))

export const normalizeReportDateParameter = (item = {}) => {
  const value = item.value
  if (value === '' || value === null || value === undefined) return value

  const isDateTime = isReportDateTimeParameter(item)
  const isDate = item.paramType === 'date' ||
    /date/i.test(item.field || item.title || '')
  if (!isDateTime && !isDate) return value

  const parsed = moment(value, moment.ISO_8601, true)
  if (!parsed.isValid()) return value

  return parsed.format(isDateTime ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD')
}
